import React from 'react';
import buildContext from '~/components/jsx-helpers/build-context';
import loadable from 'react-loadable';
import ChromeFallback from '~/components/shell/chrome-fallback';
import deepEqual from 'deep-equal';
const loaders = {
    default: () => import('~/layouts/default/default'),
    landing: () => import('~/layouts/landing/landing')
};
const defaultLayoutParameters = { name: 'default' };
const initialLayoutParameters = { name: null };
function useContextValue() {
    const [layoutParameters, setLayoutParameters] = React.useState(initialLayoutParameters);
    const updateIfNotEqual = React.useCallback((newValue) => {
        if (newValue === undefined) {
            setLayoutParameters(defaultLayoutParameters);
            return;
        }
        if (deepEqual(layoutParameters, newValue)) {
            return;
        }
        setLayoutParameters(newValue);
    }, [layoutParameters]);
    const Layout = React.useCallback(({ children }) => {
        const layoutParameterName = layoutParameters.name;
        if (layoutParameterName === null) {
            return React.createElement("div", null, children);
        }
        const LoadableLayout = loadable({
            loader: () => loaders[layoutParameterName](),
            loading: () => React.createElement(ChromeFallback, null)
        });
        // Avoids initial flash default -> landing
        return (React.createElement(LoadableLayout, { data: layoutParameters.data }, children));
    }, [layoutParameters.data, layoutParameters.name]);
    return { Layout, setLayoutParameters: updateIfNotEqual, layoutParameters };
}
const { useContext, ContextProvider } = buildContext({ useContextValue });
export { useContext as default, ContextProvider as LayoutContextProvider };
